import _ from 'lodash';
import { logger, bigQuery, mixpanel } from '@fiverr-private/obs';
import { removeEmptyEntries } from '../..';

export const createDataParams = ({ pageName, pageCtxId, gig_id, studio_id, user_id, currentUserId }) => ({
    name: pageName,
    page: {
        name: pageName,
        ctx_id: pageCtxId,
    },
    feature: {
        name: 'gig_reviews',
    },
    gig: {
        id: gig_id,
    },
    studio: {
        id: studio_id,
    },
    seller: {
        id: user_id,
    },
    user: {
        id: currentUserId,
    },
});

export const createMixPanelBasePayload = ({ pageName, gig_id, user_id, currentUserId, studio_id }) =>
    removeEmptyEntries({
        'Page Name': pageName,
        'Gig Id': gig_id,
        'Seller Id': user_id,
        'User Id': currentUserId,
        'Studio Id': studio_id,
    });

class TrackingService {
    constructor() {
        this.sendBQEvent = this.sendBQEvent.bind(this);
        this.sendMixPanelEvent = this.sendMixPanelEvent.bind(this);
    }

    initialize(state) {
        this.reportingData = createDataParams(state.getState());
        this.mixpanelBasePayload = createMixPanelBasePayload(state.getState());
    }

    getReportingData() {
        return _.cloneDeep(this.reportingData);
    }

    sendBQEvent(params = {}) {
        bigQuery.send(_.merge({}, this.reportingData, params));
    }

    sendMixPanelEvent({ eventName, eventPayload }) {
        try {
            mixpanel.track(eventName, _.merge({}, this.mixpanelBasePayload, removeEmptyEntries(eventPayload)));
        } catch (e) {
            logger.error(e, {
                message: `Failed to report event to MixPanel - ${e.message}`,
                action: 'sendMixPanelEvent',
            });
        }
    }
}

const tracker = new TrackingService();

export default tracker;
